
/* injects from baggage-loader */

'use strict';

import ProjectDonationWizardStep0Controller from './project-donation-wizard.step0.controller';
import ProjectDonationWizardStep0Template from './project-donation-wizard.step0.html';

export default class ProjectDonationWizardStep0Component {
		constructor() {
				this.templateUrl = ProjectDonationWizardStep0Template;
				this.controller = ProjectDonationWizardStep0Controller;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = { 
					project: '<',
					rewards: '<',
					donation: '<'
				};
		}
}



// WEBPACK FOOTER //
// ./src/app/pages/project-donation-wizard/step0/project-donation-wizard.step0.component.js